import React, { useState, useEffect } from 'react'
import './style.scss'

import Container from './../../components/Container'
import { mensagemErro, Icon, ModalEmpty, Modal } from './../../components/Layout'
import { SelectAsync } from './../../components/Form'
import api, { axios } from './../../api'
import { useAuth } from './../../context/Auth'

import Skeleton from 'react-loading-skeleton'

import Widget from './Components/Widget'
import LoadWidget from './Components/LoadWidget'
import SemCondicionantes from './Components/SemCondicionantes'
import Condicionante from './Components/Condicionante'
import Licencas from './Components/Licencas'
import LoadCondicionante from './Components/LoadCondicionante'
import GraficoSituacao from './Components/GraficoSituacao'
import Card from './Components/Card'
import DouInfo from './Components/DouInfo'
import GraficoTotalTipo from './Components/GraficoTotalTipo'
import Tutorial from '../../components/Tutorial'

function Dashboard() {

    const { getMenu, removeUser } = useAuth()
    const menuShow = getMenu()

    const [load, setLoad] = useState(true)
    const [vencidas, setVencidas] = useState(0)
    const [vencendo, setVencendo] = useState(0)
    const [aberta, setAberta] = useState(0)
    const [tickets, setTickets] = useState(0)

    const [dataGraficoSituacao, setDataGraficoSituacao] = useState({})
    const [dataGrafico, setDataGrafico] = useState({})
    const [dataCondicionante, setDataCondicionante] = useState([])
    const [dataDou, setDataDou] = useState([])

    const [showModalTipo, setShowModaltipo] = React.useState(false)
    const [tipoSelected, settipoSelected] = useState('Todos')
    const [runTutorial, setRunTutorial] = useState(false)

    useEffect(() => {
        const tutorialDone = localStorage.getItem('@amb:tutorialDashboardDone')
        if (!tutorialDone) {
            setRunTutorial(true)
        }
    }, [])

    const handleTutorialFinish = () => {
        localStorage.setItem('@amb:tutorialDashboardDone', 'true')
        setRunTutorial(false)
    }

    const tutorialSteps = [
        {
            target: 'body',
            content: 'Bem-vindo ao Dashboard! Aqui você tem uma visão geral do sistema.',
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '.dashboard-widgets',
            content: 'Visualize aqui os totalizadores de licenças vencidas, a vencer, em aberto e tickets.',
            placement: 'bottom',
        },
        {
            target: '.dashboard-condicionantes',
            content: 'Acompanhe a lista de condicionantes e licenças prioritárias.',
            placement: 'right',
        },
        {
            target: '.dashboard-filters',
            content: 'Utilize os filtros para refinar os dados exibidos no dashboard.',
            placement: 'left',
        },
        {
            target: '.dashboard-chart-type',
            content: 'Gráfico com o totalizador por tipo.',
            placement: 'left',
        },
        {
            target: '.dashboard-chart-situation',
            content: 'Visualize a distribuição das licenças por situação.',
            placement: 'left',
        },
        {
            target: '.dashboard-dou',
            content: 'Fique por dentro das últimas atualizações do Diário Oficial da União.',
            placement: 'left',
        }
    ]

    const [showModalQtd, setShowModalQtd] = React.useState(false)
    const [qtdItens, setQtdItens] = React.useState(10)

    const [showModalCliente, setShowModalCliente] = React.useState(false)
    const [clienteSelected, setClienteSelected] = React.useState({
        id: 0,
        name: 'Selecione um'
    })

    const [showModalSituacao, setShowModalSituacao] = React.useState(false)
    const [situacaoSelected, setSituacaoSelected] = React.useState({
        id: 0,
        name: 'Todas'
    })

    const cancelToken = axios.CancelToken

    useEffect(() => {
        onBuscaDados()

        return () => {
            cancelToken.source().cancel()
        }
    }, [tipoSelected, qtdItens, clienteSelected, situacaoSelected])

    async function onBuscaDados() {

        try {

            setLoad(true)

            const resp = await api.get(`dashboard/${tipoSelected}/${qtdItens}/${clienteSelected.id}/${situacaoSelected.id}`, {
                cancelToken: cancelToken.source().token
            })

            if (resp.data?.erro) {
                setLoad(false)
                mensagemErro(`${resp.data.erro.message}`)

                return
            }

            if (resp.status !== 200)
                console.log(resp)

            const { vencidas, vencendo, aberta, condicionantes, tickets, situacao, dou } = resp.data

            setVencidas(vencidas ? vencidas : 0)
            setVencendo(vencendo ? vencendo : 0)
            setAberta(aberta ? aberta : 0)
            setTickets(tickets ? tickets : 0)
            setDataCondicionante(condicionantes)
            setDataDou(dou)

            const COLORS = {
                info: '#2E7CF6',
                success: '#2DA44E',
                warning: '#F2C94C',
                danger: '#EB5757',
                default: '#6B6F76'
            }

            setDataGrafico({
                labels: [
                    'Vencidas',
                    'Vencendo/mês',
                    'Em Aberto'
                ],
                datasets: [{
                    data: [vencidas, vencendo, aberta],
                    backgroundColor: [
                        COLORS.danger,
                        COLORS.warning,
                        COLORS.info
                    ],
                    hoverBackgroundColor: [
                        COLORS.danger,
                        COLORS.warning,
                        COLORS.info
                    ]
                }]
            })

            const situacaoColors = situacao.label.map((label, index) => {
                const upperLabel = label ? label.toUpperCase() : '';
                if (upperLabel.includes('VIGENTE') || upperLabel.includes('CONCLUÍDO') || upperLabel.includes('OK')) return COLORS.success;
                if (upperLabel.includes('RENOVAR') && !upperLabel.includes('VENCIDA')) return COLORS.warning;
                if (upperLabel.includes('VENCIDA')) return COLORS.danger;
                if (upperLabel.includes('ABERTO')) return COLORS.info;

                return situacao.cor && situacao.cor[index] ? situacao.cor[index] : COLORS.default;
            });

            setDataGraficoSituacao({
                labels: situacao.label,
                datasets: [{
                    data: situacao.total,
                    backgroundColor: situacaoColors,
                    hoverBackgroundColor: situacaoColors
                }]
            })

            setLoad(false)

        } catch (error) {

            if (error?.response?.data?.error?.name === 'ExpiredJwtToken') {
                mensagemErro(`Sua sessão expirou. Você será redirecionado para realizar seu login novamente em 3 segundos.`)

                setTimeout(() => {
                    removeUser()
                    window.location.reload()
                }, 3000);
            }
        }
    }

    function FiltroTipo() {

        return (
            <div className="card" style={{ marginBottom: '24px' }}>
                <div className="card-body">
                    <div className="filter-header-title">
                        <Icon name='ti-filter' />
                        <span>Filtros</span>
                    </div>

                    <div className='filter-bar' style={{ marginBottom: 0 }}>
                        <div className="filter-chip" onClick={() => setShowModaltipo(true)}>
                            <div className="filter-info">
                                <span className="filter-label">Tipo</span>
                                <span className="filter-value">{tipoSelected}</span>
                            </div>
                            {tipoSelected !== 'Todos' ?
                                <div
                                    className="remove-filter"
                                    onClick={(e) => { e.stopPropagation(); settipoSelected('Todos'); }}
                                    title="Remover filtro"
                                >
                                    <Icon name='ti-close' />
                                </div>
                                :
                                <Icon name='ti-angle-down' />
                            }
                        </div>

                        {
                            String(menuShow) !== '4' &&
                            <div className="filter-chip" onClick={() => setShowModalCliente(true)}>
                                <div className="filter-info">
                                    <span className="filter-label">Cliente</span>
                                    <span className="filter-value">{clienteSelected.name}</span>
                                </div>
                                {Number(clienteSelected.id) !== 0 ?
                                    <div
                                        className="remove-filter"
                                        onClick={(e) => { e.stopPropagation(); setClienteSelected({ id: 0, name: 'Selecione um' }); }}
                                        title="Remover filtro"
                                    >
                                        <Icon name='ti-close' />
                                    </div>
                                    :
                                    <Icon name='ti-angle-down' />
                                }
                            </div>
                        }

                        <div className="filter-chip" onClick={() => setShowModalSituacao(true)}>
                            <div className="filter-info">
                                <span className="filter-label">Situação</span>
                                <span className="filter-value">{situacaoSelected.name}</span>
                            </div>
                            {Number(situacaoSelected.id) !== 0 ?
                                <div
                                    className="remove-filter"
                                    onClick={(e) => { e.stopPropagation(); setSituacaoSelected({ id: 0, name: 'Todas' }); }}
                                    title="Remover filtro"
                                >
                                    <Icon name='ti-close' />
                                </div>
                                :
                                <Icon name='ti-angle-down' />
                            }
                        </div>

                        <div className="filter-chip" onClick={() => setShowModalQtd(true)}>
                            <div className="filter-info">
                                <span className="filter-label">Itens mostrados</span>
                                <span className="filter-value">{qtdItens}</span>
                            </div>
                            <Icon name='ti-angle-down' />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const FiltroLoad = React.memo(() => {
        return (
            <div className="card" style={{ marginBottom: '24px' }}>
                <div className="card-body">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                        <Skeleton height={20} width={20} />
                        <Skeleton height={20} width={100} />
                    </div>

                    <div className='divCardFilter' style={{ marginBottom: 0 }}>
                        <div className="card">
                            <div className="card-body">
                                <span><Skeleton height={18} width={60} /></span>
                                <div><Skeleton height={20} width={20} /></div>
                            </div>
                        </div>
                        {
                            String(menuShow) !== '4' &&
                            <div className="card">
                                <div className="card-body">
                                    <span><Skeleton height={18} width={120} /></span>
                                    <div><Skeleton height={20} width={20} /></div>
                                </div>
                            </div>
                        }
                        <div className="card">
                            <div className="card-body">
                                <span><Skeleton height={18} width={60} /></span>
                                <div><Skeleton height={20} width={20} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    })

    return (
        <>
            <Container
                title='Dashboard'
                titlesub='Resumo do Ambientar'
                showWidget
                noCard
                className="dashboard-container"
            >

                <Tutorial
                    steps={tutorialSteps}
                    run={runTutorial}
                    onFinish={handleTutorialFinish}
                />

                <div className="row mb-4 dashboard-widgets">
                    {
                        load ?
                            <>
                                {
                                    [1, 2, 3, 4].map((item, index) => {
                                        return <LoadWidget key={index} />
                                    })
                                }
                            </> :
                            <Widget
                                vencidas={vencidas}
                                vencendo={vencendo}
                                aberta={aberta}
                                tickets={tickets}
                            />
                    }
                </div>

                <div className="row">
                    <div className="col-md-6 dashboard-condicionantes">
                        {
                            load ?
                                <>
                                    {
                                        [1, 2, 3].map((item, index) => {
                                            return <LoadCondicionante key={index} />
                                        })
                                    }
                                </>
                                :
                                <>
                                    {
                                        dataCondicionante.length === 0 ? <SemCondicionantes /> :
                                            dataCondicionante.map((cond, index) => {
                                                return (
                                                    cond.tipo === 'condicionante' ?
                                                        <Condicionante key={index} cond={cond} /> :
                                                        <Licencas key={index} licenca={cond} />
                                                )
                                            })
                                    }
                                </>
                        }
                    </div>
                    <div className="col-md-3 sticky-column">

                        {
                            load ? <FiltroLoad /> : <div className="dashboard-filters"><FiltroTipo /></div>
                        }

                        <div className="dashboard-chart-type">
                            <GraficoTotalTipo
                                load={load}
                                dataGrafico={dataGrafico}
                            />
                        </div>

                        {
                            dataGraficoSituacao?.labels &&
                            <div className="dashboard-chart-situation">
                                <GraficoSituacao
                                    load={load}
                                    dataGraficoSituacao={dataGraficoSituacao}
                                />
                            </div>
                        }

                    </div>
                    <div className="col-md-3 sticky-column">

                        <div className="dashboard-dou">
                            <DouInfo
                                load={load}
                                dataDou={dataDou}
                            />
                        </div>

                    </div>
                </div>

            </Container>

            {
                showModalTipo &&
                <ModalEmpty
                    title='Selecione um Tipo'
                    showButtonSave={false}
                    onClose={() => setShowModaltipo(false)}
                    setWidth={400}
                >

                    {
                        ['Todos', 'Condicionantes', 'Licenças'].map((tipo, index) => {

                            function onSelecionarTipo(_tipo) {
                                settipoSelected(_tipo)
                                setShowModaltipo(false)
                            }

                            return (
                                <div onClick={() => onSelecionarTipo(tipo)} key={index} className="mb-2">
                                    <div className='card-tipo-selecionar'>
                                        <span>{tipo}</span>
                                    </div>
                                </div>
                            )
                        })
                    }

                </ModalEmpty>
            }

            {
                showModalCliente &&
                <Modal
                    title='Selecione um Cliente'
                    onClose={() => setShowModalCliente(false)}
                    onSave={(data) => {
                        setClienteSelected({
                            id: data.cliente_id,
                            name: data.cliente_nome
                        })
                        setShowModalCliente(false)
                    }}
                    setWidth={500}
                    nomeButtonSave='Filtrar'
                >

                    <SelectAsync
                        name='cliente_id'
                        col='col-lg-12'
                        titulo='Selecione um Cliente'
                        router='cliente/combo'
                        labelValue='cliente_nome'
                    />

                </Modal>
            }

            {
                showModalSituacao &&
                <Modal
                    title='Selecione uma Situação'
                    onClose={() => setShowModalSituacao(false)}
                    onSave={(data) => {
                        setSituacaoSelected({
                            id: data.situacao_id,
                            name: data.descricao
                        })
                        setShowModalSituacao(false)
                    }}
                    setWidth={500}
                    nomeButtonSave='Filtrar'
                >

                    <SelectAsync
                        name='situacao_id'
                        col='col-lg-12'
                        titulo='Selecione uma Situação'
                        router='situacao/combo'
                        labelValue='descricao'
                    />

                </Modal>
            }

            {
                showModalQtd &&
                <ModalEmpty
                    title='Itens por tela'
                    showButtonSave={false}
                    onClose={() => setShowModalQtd(false)}
                    setWidth={400}
                >

                    {
                        [10, 20, 30, 40, 50].map((qtd, index) => {

                            function onSelecionarQtd(_qtd) {
                                setQtdItens(_qtd)
                                setShowModalQtd(false)
                            }

                            return (
                                <div onClick={() => onSelecionarQtd(qtd)} key={index} className="mb-2">
                                    <div className='card-tipo-selecionar'>
                                        <span>{qtd}</span>
                                    </div>
                                </div>
                            )
                        })
                    }

                </ModalEmpty>
            }
        </>
    )
}

export default Dashboard